import { isValidBasicStringOfLengthN } from '../validators'

export const isValidCircleCIProjectSlug = (projectSlug: string): boolean | string => {
  const projectSlugArray = projectSlug.split('/')

  const isValid =
    projectSlugArray.length === 3 && projectSlugArray.every(item => isValidBasicStringOfLengthN(1)(item) === true)

  return isValid ? true : 'Project slug is invalid.'
}
